<template>
    <div>
        <div class="bg-light shadow-md rounded mt-3 p-2">
            <!-- Expediente -->            
            <div class="row">
                <div class="col-6 col-md-2">
                    <span class="small">Expediente</span>
                    <p class="text-warning"><b>{{ E.exp }}</b></p>
                </div>
                <div class="col-6 col-md-2">
                    <span class="small">Referencia</span>
                    <p><b>{{ E.ref }}</b></p>
                </div>
                <div class="col-6 col-md-2">
                    <span class="small">Area</span>
                    <p><b>{{ E.departa }}</b></p>
                </div>
                <div class="col-6 col-md-4">
                    <span class="small">Duración</span>
                    <p><b>{{ E.duracion }}</b></p>
                </div>
                <div class="col-12 col-md-2">
                    <b-button size="sm" variant="outline-info" class="my-2 mx-2" @click="excel">EXCEL</b-button>
                    <b-button size="sm" variant="outline-info" class="my-2" @click="calculos">
                        <b-icon icon="info-circle-fill" aria-hidden="true"></b-icon>
                    </b-button>
                </div>
            </div>
            <hr class="m-0">
            <div class="row p-0">
                <div class="col-12 col-md-6">
                    <!-- <i class="fas fa-utensils text-secondary pr-1"></i> -->
                    <span class="small">Contrato/Descripcón</span><br>
                    <span><b>{{ E.contrato }}</b></span>
                </div>
                <div class="col-12 col-md-6">
                    <span class="small">Cliente</span><br>
                    <span><b>{{ E.c1 }}</b></span>
                    <span v-show="E.c2" class="small"><b><br>{{ E.c2 }}</b></span>
                    <span v-show="E.c3" class="small"><b><br>{{ E.c3 }}</b></span>
                    <!-- <span class="small"><b><br>{{ E.cpob }}</b></span> -->

                </div>
            </div>
        </div>

        <div class="my-0">
            <b-card no-body>
                <b-tabs pills card horizontal
                    active-nav-item-class="font-weight-bold text-uppercase">
                    <b-tab :active="tab==1">
                        <template #title>
                            <i class="mr-2 fas fa-credit-card"></i><span class="nav-item"> Documentación </span>
                        </template>
                        <b-card>                         
                            <h4>DOCUMENTOS</h4>                            
                            <b-list-group>
                                <b-list-group-item button                                   
                                    class="flex-column align-items-start"
                                    v-for="item in ED"
                                    v-bind:key="item.id">
                                    <!-- <div class="d-flex w-100 justify-content-between"> -->
                                    <div class="d-flex w-100 left-content-between">
                                        <b-btn size="sm" variant="light" class="p-1" 
                                                v-b-tooltip.hover title="Ver"
                                                @click="documento(item)"
                                            ><b-icon icon="search"></b-icon>                                            
                                        </b-btn>
                                        <h6 class="p-1 mb-1"><b>{{ item.name }}</b></h6>
                                            
                                    </div>
                                    <p class="mb-2">{{ item.des }}</p>
                                </b-list-group-item>
                            </b-list-group> 
                        </b-card>
                    </b-tab>
                    <b-tab :active="tab==2">
                        <template #title>
                            <i class="mr-2 fas fa-credit-card"></i><span class="nav-item"> Facturas </span>
                        </template>                    
                        <b-card>   
                            <facturas                                
                                :FE="EFE"           
                                :FR="EFR"
                            />                                                       
                        </b-card>
                    </b-tab>                    
                    <b-tab :active="tab==3">
                        <template #title>
                            <i class="mr-2 fas fa-user"></i>Personal
                        </template>            
                        <b-card>
                            <nominas                                
                                :EMP="EEN"                                           
                            />     
                            <!-- <small>{{ EEN }}</small> -->
                        </b-card>
                    </b-tab>                                       
                    <b-tab :active="tab==4">
                        <template #title>
                            <i class="mr-2 fas fa-bell"></i>Notificaciones                                                                    
                        </template>
                        <b-card>
                            <b-card-text>
                                <h4> No hay Notificaciones</h4>                    
                            </b-card-text>
                        </b-card>
                    </b-tab>
                </b-tabs>
            </b-card>
        </div> 

        <calculos :ECC="ECC"/>                                                     

    </div>
</template>

<script>

import { mapState, mapMutations, mapActions } from 'vuex';

import facturas from '@/components/facturas.vue';
import nominas from '@/components/nominas.vue';

import calculos from '@/components/exped_calculos.vue'

export default {
    name: 'exped',
    components: {
        facturas, nominas, calculos,
        
    },
    data() {
        return {
            message: 'Error',
            tab: 1,

            E: {id:0},
            ED: [],
            EFE: [],
            EFR: [],
            EEN: [],
            ECC: [],

        };
    },

    created() {
        // if (!this.$store.state.auth.logueado) this.$router.push('/');
        // if (!this.$store.state.exped.id==0) this.$router.push('/expedientes');
        if (!this.auth.logueado)    this.$router.push('/');        
        if (this.exped.id==0)       this.volver(); else this.leemos();

    },

    computed: {        
        ...mapState(['G','auth','exped','errores']),  

        usuario() {
            return this.auth.user;
        },      
        
        exp() {
            return Number(this.E.id);
        }

    },
    methods: {
        ...mapMutations(['loading','alerta','modal']),
        ...mapActions(['exec']),

        async leemos() {
            console.log("** exped.leemos",this.exped);
            this.loading();
            
            let r=await this.exec({api:'exped',
                arg: { token: this.auth.token, fnt:'get', id: this.exped.id } 
            });

            console.log("** exped.leemos resultado: ",r);

            if (r.error) {
                //mensaje error modal ... mostrar r.datos
                this.modal({tit:"EXPEDIENTES", msg:r.datos});
                r.datos=[];
                this.volver();
            } 
            let D=Object.values(r.datos);     console.log(D);

            //guardamos datos
            this.E=D[0];
            //docs
            this.ED=D[1];
            //facturas
            this.EFE=Object.values(D[2]);
            this.EFR=Object.values(D[3]);
            //empleados
            this.EEN=Object.values(D[4]); //D[4];
            //calculos
            //this.ECC=Object.values(D[5]);
            this.ECC=D[5];

            
            this.loading(false);
        },

        async documento(item) {
            //this.loading();                
            let r=await this.exec({api:'documento', 
                arg: { token: this.auth.token, id: item.id }
            });
            console.log('documento',r);
            if (r.error) { 
                this.modal({tit:"DOCUMENTO", msg:r.datos});                  
                return;
            }                     
            // abro documento
            window.open(this.$store.state.G.url_tmp + r.datos[0], "_blank");                                    
            //this.loading(false);
        },

        async excel() {
            //this.loading();                
            let r=await this.exec({api:'exped_xls', 
                arg: { token: this.auth.token, id: this.E.id }
            });
            
            if (r.error) { 
                this.modal({tit:"EXCEL EXPEDIENTE", msg:r.datos});                  
                return;
            }                     
            // abro documento
            window.open(this.$store.state.G.url_tmp + r.datos[0], "_blank");                                    
            //this.loading(false);
        },

        volver() {
            this.$router.push('/expedientes');
            this.exped={id:0};
        },

        calculos() {
            //alert('calculos');
            this.$bvModal.show("modal_calculos");

        },                
        
    },
}
</script>
